import { useTranslation } from 'react-i18next';

import { Spinner } from '@pulse-web-ui/spinner';

import { LoadingContainer } from './page-loader.styles';

export const PageLoader = () => {
  const { t } = useTranslation('COMMON');

  return (
    <LoadingContainer>
      <Spinner size={40} />
      {t('labels.loading')}
    </LoadingContainer>
  );
};
